var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderMypage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 331,
    height: 134,
    viewBox: "0 0 331 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18649",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18649",
    transform: "translate(-21 -339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18647",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18647",
    transform: "translate(21 339)",
    opacity: 0.997
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5679",
    "data-name": "\\u6955\\u5186\\u5F62 5679",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17082",
    "data-name": "\\u9577\\u65B9\\u5F62 17082",
    width: 183,
    height: 18,
    rx: 9,
    transform: "translate(53 1)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17083",
    "data-name": "\\u9577\\u65B9\\u5F62 17083",
    width: 92,
    height: 13,
    rx: 6.5,
    transform: "translate(53 27)",
    fill: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18648",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18648",
    transform: "translate(21 401.739)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_5679-2",
    "data-name": "\\u6955\\u5186\\u5F62 5679",
    cx: 22.5,
    cy: 22,
    rx: 22.5,
    ry: 22,
    transform: "translate(0 0.26)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17082-2",
    "data-name": "\\u9577\\u65B9\\u5F62 17082",
    width: 136,
    height: 17,
    rx: 8.5,
    transform: "translate(53 2.26)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17083-2",
    "data-name": "\\u9577\\u65B9\\u5F62 17083",
    width: 53,
    height: 14,
    rx: 7,
    transform: "translate(53 27.26)",
    fill: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17085",
    "data-name": "\\u9577\\u65B9\\u5F62 17085",
    width: 331,
    height: 65,
    transform: "translate(21 408)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderMypage);
export default __webpack_public_path__ + "static/media/placeholder-mypage.fdde23941108341a327f12f3ab78e45d.svg";
export { ForwardRef as ReactComponent };